import { AxiosInstance } from 'axios';
import { authConfig } from '../config';
import { wait } from '@/common/utils/wait.ts';

/**
 * Sets up an authentication interceptor on the provided Axios instance.
 * Redirects to /api/login when any API request returns a 401 status.
 *
 * @param axiosInstance - The Axios instance to attach the interceptor to
 */
export function setupAuthInterceptor(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        const currentUrl = window.location.href;

        // Redirect to the login endpoint
        window.location.replace(
          `${authConfig.urls.LOGIN}?redirectUri=${encodeURIComponent(currentUrl)}`
        );
        // Wait for the redirect to avoid flash of error page
        await wait(1000);
      }
      return Promise.reject(error);
    }
  );
}
